import { sectionConfig } from "@/lib/section-config";
import { responsiveImageFragment } from "@/lib/fragments";


// const API_URL = process.env.DATOCMS_API_URL;
const API_TOKEN = process.env.DATOCMS_API_TOKEN;

let endpoint = process.env.DATOCMS_API_URL;

if (process.env.DATOCMS_ENVIRONMENT && process.env.DATOCMS_ENVIRONMENT !== "") {
  endpoint += `/environments/${process.env.DATOCMS_ENVIRONMENT}`;
}

/**
 *
 * @param {string} query
 * @param {object} param1
 * @returns
 */

export async function fetchAPI(query, { variables, preview, apiToken } = {}) {
  let token = apiToken ? apiToken : API_TOKEN;
  if (query?.loc)
    query = query.loc.source.body; // if we using gql
  const res = await fetch(endpoint + (preview ? "/preview" : ""), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  const json = await res.json();
  if (json.errors) {
    console.log('query: ', JSON.stringify(query))
    console.log('variables: ', JSON.stringify(variables))
    console.log(JSON.stringify(json.errors));
    console.error(json.errors);
    throw new Error("Failed to fetch API");
  }
  return json.data;
}

/**
 * This method is responsible to get all results
 * The while method will be executed until total be get.
 * @param {string} query 
 * @param {string} key 
 * @param {object} param2 { variables }
 * @returns List of results
 */
export async function fetchPages(query, key, { variables } = {}) {
  variables = variables || {};
  const total = variables.first || 9999;
  variables.first = variables.first || 100;
  variables.skip = variables.skip || 0;
  const allData = [];

  let data = await fetchAPI(query, { variables });
  allData.push(...data[key]);
  variables.skip = variables.skip + variables.first;

  while (allData.length < total && data[key]?.length > 0) {
    data = await fetchAPI(query, { variables });
    allData.push(...data[key]);
    variables.skip = variables.skip + variables.first;
  }

  return allData;
}

export async function fetchComponentRelations(
  { sections },
  locale,
  preview = false
) {
  let relations = {};
  if (!sections) return relations;

  await Promise.all(
    sections.map(async (slice) => {
      let Component = sectionConfig[slice.__typename];
      if (!Component || !Component.query) return true;

      let args = Component.variables ? Component.variables(slice) : {};
      let query = `${Component.query}${responsiveImageFragment}`;
      let componentQuery = await fetchAPI(query, {
        variables: { ...args, locale },
        preview,
      });
      relations[slice.__typename] = componentQuery;
    })
  );

  return relations;
}

export function createPagePaths(records, context) {
  let paths = [];
  records.map((item) => {
    if (item._allSlugLocales) {
      let def = item._allSlugLocales.find(
        (item) => item.locale === process.env.DEFAULT_SITE_LOCALE
      );
      item._allSlugLocales.map((slug) => {
        if (context.locales.indexOf(slug.locale) === -1) return;
        let value = slug.value ? slug.value : def.value;
        paths.push({ params: { slug: value }, locale: slug.locale });
      });
    } else {
      context.locales.map((locale) => {
        paths.push({ params: { slug: item.slug }, locale: locale });
      });
    }
  });
  return paths;
}


